export default {
  "content": "<path fill=\"#BBB\" d=\"M26.667 0A3.335 3.335 0 0130 3.333V5H0V3.333A3.333 3.333 0 013.333 0h23.334zM30 20a3.336 3.336 0 01-3.333 3.333H3.333A3.335 3.335 0 010 20V10h30v10z\"/><circle cx=\"13.5\" cy=\"16.5\" r=\"1.5\" fill=\"#fff\"/><circle cx=\"18.5\" cy=\"16.5\" r=\"1.5\" fill=\"#fff\"/><circle cx=\"23.5\" cy=\"16.5\" r=\"1.5\" fill=\"#fff\"/><rect width=\"18.5\" height=\"6.5\" x=\"9.25\" y=\"13.25\" stroke=\"#EA3917\" stroke-width=\".5\" rx=\"2.75\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "30",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 30 24"
  }
};